module.exports = __webpack_public_path__ + "static/express_12-c158bd37bf0a85fb877afe472daa0d59.jpg";